import { useEffect } from 'react';
import { SupportTicketsTable } from '@/components/Templates/SupportTickets';

const SupportTickets = () => {	
	return <SupportTicketsTable />;
};

export default SupportTickets;

